import { render } from "./GalleryFolderList.vue?vue&type=template&id=915d4b7e"
import script from "./GalleryFolderList.vue?vue&type=script&lang=js"
export * from "./GalleryFolderList.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__